import {
  CATEGORY_SLUG_INDEX,
  SUBCATEGORY_SLUG_INDEX,
} from './useCurrentCategory.constants';
import { ROOT_CATEGORY_SLUG } from '@/constants/common';
import { NEW_AD_PAGE_SLUG } from '@/hooks/usePageType/usePageType.constants';

export function getCurrentCategoryPath(
  slug: string | string[] | undefined
): string {
  return [
    slug?.[CATEGORY_SLUG_INDEX],
    slug?.[SUBCATEGORY_SLUG_INDEX],
  ].reduce<string>(
    (acc, s) => (s && s !== NEW_AD_PAGE_SLUG ? `${acc}/${s}` : acc),
    ROOT_CATEGORY_SLUG
  );
}
